module.exports = __webpack_public_path__ + "img/bank-sync-effects.fc99909e.svg";